"use client"
import React from 'react'
import Navbar from '../../components/admin/common/Navbar';
import MainApplication from '../../components/admin/Lead/Application/MainApplication';

const AdminApplications = () => {

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
       <MainApplication/>
      </main>
    </div>
  )
}

export default AdminApplications
